import { stringify } from 'qs';
import func from '../../utils/Func';
import request from '../../utils/request';
import { getSiteIp } from '@/utils';



export async function list(params) {
  return request(`/api/blade-mbs/file-info/page?${stringify(params)}`);
}

export async function detailList(params) {
  return request(`/api/blade-mbs/file-detail/details?${stringify(params)}`);
}

export async function submit(params) {
  return request('/api/blade-mbs/file-info/submit', {
    method: 'POST',
    body: params,
  });
}

export async function update(params) {
  return request('/api/blade-mbs/file-info/update', {
    method: 'POST',
    body: params,
  });
}

export async function detail(params) {
  return request(`/api/blade-mbs/file-info/detail?${stringify(params)}`);
}

export async function remove(params) {
  return request('/api/blade-mbs/file-info/remove', {
    method: 'POST',
    body: func.toFormData(params),
  });
}

export async function detailRemove(params) {
  return request('/api/blade-mbs/file-detail/remove', {
    method: 'POST',
    body: func.toFormData(params),
  });
}

export async function createFile(params) {
  const payload = { ...params, siteIp: getSiteIp() };
  return request('/api/blade-mbs/file-info/create-file', {
    method: 'POST',
    body: func.toFormData(payload),
  });
}

export async function uploadInfo(params) {
  return request(`/api/blade-mbs/file-info/upload-info/${params}`);
}

export async function completeFile(params) {
  return request(`/api/blade-mbs/file-info/complete-file/${params}`, {
    method: 'POST',
  });
}

export async function queryPlatTypeById(params) {
  return request(`/api/blade-mbs/mbs-platform/detail?${stringify(params)}`);
}

export async function createProgram(params) {
  return request('/api/blade-mbs/program/create', {
    method: 'POST',
    body: func.toFormData(params),
  });
}

export async function createAutoProgram(params) {
  return request('/api/blade-mbs/program/autoCreate', {
    method: 'POST',
    body: func.toFormData(params),
  });
}

export async function ossDownload(params) {
  return request(`/api/blade-mbs/file-info/download-info/${params}`);
}

export async function ossPreview(params) {
  return request(`/api/blade-mbs/file-info/view-info/${params}`);
}

export async function checkOnline(params) {
  return request(`/api/blade-mbs/stream/check-online?${stringify(params)}`);
}

export async function getConnections(params) {
  return request(`/api/blade-mbs/stream/connection-info?${stringify(params)}`);
}

export async function downLoadFile(params) {
  const { fileInfoId, ...payload } = { ...params, siteIp: getSiteIp() };
  return request(`/api/blade-mbs/file-info/download-url/${fileInfoId}?${stringify(payload)}`);
}
